export enum QuotationStatus {
    sale = 'Accepted',
    declined = 'Rejected',
    cancel = 'Cancelled',
    requested = 'Quotation request',
    draft = 'New Quote (Draft)',
    sent = 'Sent',
}

export enum QuotationDescriptionStatus {
    sale = 'Converted to order',
    declined = 'Rejected by retailer',
    cancel = 'Canceled by me',
    requested = 'Quotation request by retailer',
    draft = 'Expires in',
    sent = 'Quotation Sent by me',
}

export enum QuotationHistoryStatus {
    QUOTATION_ACCEPTED = 'Accepted',
    QUOTATION_DECLINED = 'Rejected',
    QUOTATION_DRAFTED = 'New Quote (Draft)',
    QUOTATION_REQUESTED = 'Quotation request',
    QUOTATION_CANCELED = 'Canceled',
    QUOTATION_SENT = 'Sent',
}


export enum OrderStatusEnum {
    pending = 'pending',
    started = 'started',
    partial = 'partial',
    full = 'full',
}

export enum OrderPaymentStatusEnum {
    not_paid = 'not paid',
    in_payment = 'in payment',
    paid = 'paid',
    partial = 'partial',
    reversed = 'reversed',
}

// Lifecycle statuses for AI-processed order placeholders. Kept separate from
// QuotationStatus (a value-as-label enum) so shipping/quotation code paths can
// never resolve a lifecycle pill.
export enum AtoProcessingStatus {
    processing = 'processing',
    needs_review = 'needs_review',
    completed = 'completed',
}
